import React, { useState } from "react";
import axios from "axios";
import { Modal, Col } from "reactstrap";

const NewCreatorModal = ({ onUserCreated }) => {
    const [open, setOpen] = useState(false);

    const [form, setForm] = useState({
        user_NAME: "",
        user_SURNAME: "",
        user_PHONE: "",
        user_EMAIL: "",
        user_PWD: ""
    });

    const toggle = () => setOpen(!open);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        // Validation simple côté front
        if (!form.user_NAME || !form.user_SURNAME || !form.user_PHONE || !form.user_EMAIL || !form.user_PWD) {
            return alert("Tous les champs sont requis !");
        }

        try {
            // 1️⃣ Créer le créateur dans la BDD
            const res = await axios.post("/api/user/createCreator", form, { withCredentials: true });
            const newUser = res;

            await axios.post(
                "/api/admin/create-user-root",
                { email: form.user_EMAIL },
                { withCredentials: true }
            );

            // 3️⃣ Rafraîchir la liste des créateurs
            onUserCreated();

            // 4️⃣ Fermer la modal
            toggle();
        } catch (err) {
            console.error(err.response?.data || err);
            alert(err.response?.data?.error || "Erreur lors de la création du créateur ou du dossier");
        }
    };


    return (
        <>
            <button
                title="Ajouter un nouveau compte créateur"
                className="btn btn-outline-primary" onClick={toggle}>
                <i className="mdi mdi-account-plus-outline fs-4 py-0 align-middle"></i> Nouveau créateur
            </button>

            <Modal isOpen={open} toggle={toggle}>
                <div className="modal-header">
                    <h5 className="modal-title">Nouvel utilisateur</h5>
                    <button className="close" onClick={toggle}>
                        &times;
                    </button>
                </div>

                <div className="modal-body">
                    {[
                        { label: "Nom", name: "user_NAME" },
                        { label: "Prénom", name: "user_SURNAME" },
                        { label: "Téléphone", name: "user_PHONE" },
                        { label: "Email", name: "user_EMAIL", type: "email" },
                        { label: "Mot de passe", name: "user_PWD", type: "password" }
                    ].map(({ label, name, type }) => (
                        <Col md={12} key={name}>
                            <div className="form-floating mb-3">
                                <input
                                    type={type || "text"}
                                    className="form-control"
                                    name={name}
                                    value={form[name]}
                                    onChange={handleChange}
                                />
                                <label>{label}</label>
                            </div>
                        </Col>
                    ))}
                </div>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={toggle}>
                        Annuler
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Créer
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default NewCreatorModal;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
